<template>
    <div class="popover-leave-age" v-click-outside="popperHidden">
        <button ref="reference"
                :class="`leave-age ${getBtnClass(leave.duration_type)} ${getPendingClass()}`"
                @click="toggle"/>

        <div ref="popper" v-show="showPopper" class="popper" role="tooltip">
            <div class="popover-body">
                <div class="rounded p-primary">
                    <p class="default-font-color mb-0">
                        {{ $t(leave.duration_type) }}
                    </p>
                    <p class="text-muted mb-0">
                        <leave-date-and-time :row-data="leave"/>
                    </p>
                    <hr class="my-2"/>
                    <p class="text-muted">
                        {{ comment.comment }}
                    </p>
                    <div class="d-flex align-items-center justify-content-between">
                        <div v-for="(attachment, i) in leave.attachments" :key="i">
                            <a :href="attachment.full_url" target="_blank">
                                <i data-feather="external-link"/>
                            </a>
                        </div>
                        <div>
                            <a href="#" @click.prevent="openResponseLogModal">
                                <app-icon name="activity"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popper__arrow" data-popper-arrow></div>
        </div>
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import {leaveDateAndTimeFormat} from "../Helper/Helper";
import LeaveDateAndTime from "./LeaveDateAndTime";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";

export default {
    name: "LeaveAgePopover",
    components: {LeaveDateAndTime},
    extends: CoreLibrary,
    props: {
        leave: {

        },
        active: {

        },
        range: {

        }
    },
    data () {
        return {
            showPopper: false,
            btnClass: {
                first_half: 'age-length-half',
                last_half: 'age-length-half',
                single_day: 'age-length-full',
                multi_day: 'age-length-full',
                hours: 'age-length-quarter'
            }
        }
    },
    watch: {
        active: {
            handler: function (active) {
                if (active !== `popper-${this.leave.id}-${this.range}`) {
                    this.showPopper = false;
                }
            }
        },
        showPopper(visible) {
            if (visible) {
                this.$nextTick(() => this.createPopperInstance());
            } else {
                this.destroyPopperInstance();
            }
        }
    },
    beforeUnmount() {
        this.destroyPopperInstance();
    },
    methods: {
        createPopperInstance() {
            if (this.popperInstance || !this.$refs.reference || !this.$refs.popper) return;
            this.popperInstance = createPopper(this.$refs.reference, this.$refs.popper, {
                placement: 'top',
                modifiers: [{ name: 'offset', options: { offset: [0, 8] } }],
            });
        },
        destroyPopperInstance() {
            if (this.popperInstance) {
                this.popperInstance.destroy();
                this.popperInstance = null;
            }
        },
        toggle() {
            if (this.showPopper) {
                this.popperHidden();
            } else {
                this.popperVisible();
            }
        },
        openResponseLogModal() {
            this.showPopper = false;
            this.$emit('openResponseLogModal', this.leave.id);
            this.$emit('activePopper', 0);
        },
        popperVisible() {
            this.showPopper = true;
            this.$emit('activePopper', `popper-${this.leave.id}-${this.range}`);
        },
        popperHidden() {
            this.showPopper = false
        },
        getBtnClass(duration_type) {
            return this.btnClass[duration_type] || ''
        },
        getPendingClass() {
            return this.leave.status?.name === 'status_pending' ? 'bg-pending' : '';
        },
    },
    computed: {
        leaveDateTime(){
            return leaveDateAndTimeFormat(this.leave.start_at, this.leave.end_at)
        },
        comment() {
            return this.leave.comments && this.leave.comments.length ? this.leave.comments[0] : {};
        }
    }
}
</script>

<style lang="scss">
.popper {
    border: none;
    max-width: 25rem;
    border-radius: 7px;
    text-align: initial;
    box-shadow: var(--default-box-shadow);
    background-color: var(--default-card-bg);

    &[x-placement^="top"],
    &[x-placement^="bottom"] {
        .popper__arrow {
            border-color: var(--default-card-bg);
        }
    }

    .popover-header {
        display: none;
    }

    .popover-body {
        z-index: 2;
        padding: 0;
        border: none;
    }
}
</style>